import doc                           from '@widesk-core/decorators/doc';
import AbstractPushNotificationModel from './AbstractPushNotificationModel';
import { Translatable }              from '@widesk-core/decorators/translatable';
import { RenderNameProps }           from '@widesk-ui/mixins/ApiModelRenderName';

@doc.urnResource('push_notification')
@doc.translatable({ title: true, text: true, url: true })
class PushNotificationModel extends AbstractPushNotificationModel {
	public get pagePathPrefix() {
		return `/website_entertainments/${this.get('websiteEntertainment.id')}`;
	}

	public renderName(props?: RenderNameProps<this> & PushNotificationNameProps) {
		return super.renderName(props);
	}
}

interface PushNotificationModel
	extends Translatable<{ title: true, text: true, url: true }> {
}

export default PushNotificationModel;